<template>
    <div ref="billTableDom" v-loading="loading">
        <div class="search-part">
            <el-button plain :color="'#e91e63'" style="float: right" @click="goRenewPage" tkey="3D店鋪續期">{{i18n.tkey("lang_three_shop_renew")}}</el-button>

            <el-input
                    v-model="keyword"
                    class="w-50 m-2"
                    size="large"
                    :placeholder="i18n.tkey('lang_search_order_ref')"
                    :prefix-icon="Search"
                    clearable
                    @change="changeKeyword"
                    style="width: 50%;"
            />
        </div>

        <div style="text-align: right; ">
            <span style="font-size: 12px; color: #303133"><span tkey="3D店鋪有效期">{{i18n.tkey("lang_three_shop_exp")}}</span>:&nbsp;</span><shopExpirationSpan />
        </div>

        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="commonref" :label="i18n.tkey('lang_order_no')" width="200" v-if="width > 1080" />

            <el-table-column prop="addinfo3" :label="i18n.tkey('lang_bill_email')" width="250" v-if="width > 1080" />

            <el-table-column prop="inputdate" :label="i18n.tkey('lang_order_date')" width="160" v-if="width > 1080" />

            <el-table-column prop="date" :label="i18n.tkey('lang_state')" width="80" v-if="width > 1080" >
                <template #default="scope">
                    <div style="align-items: center">
                        <span>{{ getDataStatus(scope.row) }}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column prop="name" :label="i18n.tkey('lang_bill_total')" width="200" v-if="width > 1080" >
                <template #default="scope">
                    <div style="align-items: center">
                        <span>{{scope.row.totalsum}} {{getBoCurr(scope.row)}}</span>
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="i18n.tkey('lang_operate')" v-if="width > 1080" >
                <template #default="scope">
                    <div style="align-items: center">
                        <paypalButton v-if="scope.row.completedpayment != -1 && scope.row.verify != -1" style="margin-bottom: 5px" @click="reSubmitOrder(scope.row)" />
<!--                        <el-button type="primary" style="margin-left: 10px; margin-bottom: 5px;" v-if="scope.row.verify == 1" >重新提交</el-button>-->
                        <el-button type="primary" style="margin-left: 10px; margin-bottom: 5px;" @click="goDetail(scope.row)" tkey="詳情">{{i18n.tkey("lang_details")}}</el-button>
                        <el-button type="danger" style="margin-left: 10px; margin-bottom: 5px;" v-if="scope.row.completedpayment == 0 && scope.row.verify == 0" @click="delBo(scope.row)" tkey="刪除">{{i18n.tkey("lang_delete")}}</el-button>
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="i18n.tkey('lang_apply_information')" v-if="width <= 1080" >
                <template #default="scope">
                    <ul class="mobile-data-ul">
                       <li>
                           <span tkey="訂單號">{{i18n.tkey("lang_order_no")}}:&nbsp;</span><span>{{scope.row.commonref}}</span>
                       </li>

                        <li>
                            <span tkey="下單者郵箱">{{i18n.tkey("lang_bill_email")}}:&nbsp;</span><span>{{scope.row.addinfo3}}</span>
                        </li>

                        <li>
                            <span tkey="下單日期">{{i18n.tkey("lang_order_date")}}:&nbsp;</span><span>{{scope.row.inputdate}}</span>
                        </li>

                        <li>
                            <span tkey="狀態">{{i18n.tkey("lang_state")}}:&nbsp;</span><span>{{getDataStatus(scope.row)}}</span>
                        </li>

                        <li>
                            <span tkey="總金額">{{i18n.tkey("lang_bill_total")}}:&nbsp;</span><span>{{scope.row.totalsum}} {{getBoCurr(scope.row)}}</span>
                        </li>
                    </ul>

                    <div style="text-align: right;">
                        <paypalButton v-if="scope.row.completedpayment != -1 && scope.row.verify != -1" style="margin-bottom: 5px" @click="reSubmitOrder(scope.row)" />
<!--                        <el-button type="primary" style="margin-left: 10px; margin-bottom: 5px;" v-if="scope.row.verify == 1" >重新提交</el-button>-->
                        <el-button type="primary" style="margin-left: 10px; margin-bottom: 5px;" @click="goDetail(scope.row)" tkey="詳情">{{i18n.tkey("lang_details")}}</el-button>
                        <el-button type="danger" style="margin-left: 10px; margin-bottom: 5px;" v-if="scope.row.completedpayment == 0 && scope.row.verify == 0" @click="delBo(scope.row)" tkey="刪除">{{i18n.tkey("lang_delete")}}</el-button>
                    </div>
                </template>
            </el-table-column>

        </el-table>

        <paginationComponent :pageObj="pageObj" @goPage="changePage" style="border-top: 0" />

        <paypalForm v-if="null != rePayObj" :formObj="rePayObj" @submit-complete="submitComplete" />

        <el-dialog
                v-model="dialogVisible"
                :title="i18n.tkey('lang_bill_record_detail')"
                :width="width"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
        >
            <billDetail v-if="null != detailObj" :obj="detailObj" />
        </el-dialog>
    </div>

</template>

<script setup>
    import {ref, toRef, getCurrentInstance, onMounted, inject} from 'vue'
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import paypalButton from "@/components/shopopee/button/paypalButton"
    import paypalForm from "@/components/shopopee/form/paypalForm"
    import shopExpirationSpan from "@/components/shopopee/shop/shopExpirationSpan"
    import billDetail from "@/components/shopopee/bill/billDetail"
    import { useUserinfo } from "@/stores/userinfo"
    import {Search} from '@element-plus/icons-vue';
    import boApi from "@/request/boApi";
    import myUtil from "@/util/util";

    const { proxy } = getCurrentInstance()
    const userInfoRef = toRef(useUserinfo())

    const i18n = inject("i18n")
    const width = ref(475)

    const loading = ref(false)
    const keyword = ref("")

    const tableData = ref([])
    const detailObj = ref(null)
    const dialogVisible = ref(false)

    const pageObj = ref({})
    const pageNum = ref(1)
    const pageSize = ref(10)

    //需要重新付款的订单
    const rePayObj = ref(null)

    function getBoByPage() {
        loading.value = true
        const request = boApi.queryInsideBoByPage
        const params = request.getParams()

        params.companycode = userInfoRef.value.companycode
        params.commonref = keyword.value
        params.pageNum = pageNum.value
        params.pageSize = pageSize.value

        request.send(params, getBoCallback)
    }

    function getBoCallback(res) {
        loading.value = false
        if (res.code == 200){
            const obj = res.detail

            pageObj.value = obj
            tableData.value = obj.list

        }else{
            myUtil.alertError(res.msg)
            pageObj.value = {}
            tableData.value = []
        }
    }

    function changeKeyword(){
        getBoByPage()
    }

    function changePage(page){
        pageNum.value = page

        getBoByPage()
    }

    function getDataStatus(obj){
        let state = i18n.tkey("lang_unpaid")

        if (obj.completedpayment == -1){
            state = i18n.tkey("lang_paid")

            if (obj.verify == 0){
                state = i18n.tkey("lang_under_review")
            }
        }

        if(obj.verify == 1){
            state = i18n.tkey("lang_approval_failed")
        }

        if (obj.verify == -1){
            state = i18n.tkey("lang_completed")
        }

        return state
    }

    function getBoCurr(obj){
        let curr = "HKD"

        if (null != obj.boproducts && obj.boproducts.length > 0){
            curr = obj.boproducts[0].curr
        }

        return curr
    }

    function reSubmitOrder(obj){
        loading.value = true
        let curr = "HKD"

        if (null != obj.boproducts && obj.boproducts.length > 0){
            curr = obj.boproducts[0].curr
        }

        rePayObj.value = {
            fromtitle: "shopopee_apply_auth_" + obj.commonref,
            fromnumber: obj.commonref,
            fromamout: obj.totalsum,
            fromcurr: curr
        }
    }

    function submitComplete(){
        rePayObj.value = null
        loading.value = false
    }

    function delBo(obj){
        myUtil.confirmWarning(i18n.tkey("lang_delete_confirm"), () => {
            loading.value = true

            const request = boApi.delInsideBo
            const params = request.getParams()

            params.commonref = obj.commonref
            params.id = obj.id

            request.send(params, (res) => {
                loading.value = false
                if (res.code == 200){
                    myUtil.alertSuccess(i18n.tkey("lang_delete_success"))
                    getBoByPage()
                }else{
                    myUtil.alertError(res.msg)
                }
            })
        })
    }

    function goDetail(obj){
        detailObj.value = obj
        dialogVisible.value = true
    }

    function goRenewPage(){
        location.href = `${proxy.$ShopopeeUrl}apply_renew`
    }

    onMounted(() => {
        width.value = proxy.$refs.billTableDom.offsetWidth

        getBoByPage()
    })
</script>

<style scoped>
    .mobile-data-ul {
        list-style: none;
        padding-left: 0;
    }

    .mobile-data-ul li {
        margin-bottom: 5px;
    }

    .search-part {
        text-align: left;
        margin-top: 10px;
        margin-bottom: 20px;
    }
</style>